<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center" mt-5>
        <h1 class="mb-4">Sign Up</h1>

        <div
          style="
            width: 100%;
            height: 20px;
            border-bottom: 1px solid black;
            text-align: center;
          "
        >
<!--          <span
            style="font-size: 20px; background-color: #f3f5f6; padding: 0 10px"
          >
            Or
            &lt;!&ndash;Padding is optional&ndash;&gt;
          </span>-->
        </div>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 mt-3>
        <form @submit.prevent="userSignUpStep1" v-if="signUpStep1">
          <!-- <v-form ref="form" @submit.prevent="userSignUpStep1" v-if="signUpStep1"> -->
          <v-flex>
            <h4 class="my-4">Add Profile</h4>
          </v-flex>
          <v-layout column>
            <v-flex>
              <div class="alert alert-danger" v-if="error || errorMessage">
               <p v-if="error"> {{ error }} </p> 
                <p v-else-if="errorMessage">{{ errorMessage }} </p>
              </div>
            </v-flex>
            <v-flex v-if="!sentVerificationEmail">
              <div class="form-group" style="width: 48%; float: left">
                <label for="exampleFormControlInput1">First Name</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="First Name"
                  name="firstName"
                  v-model="firstName"
                  required
                />
              </div>
              <div class="form-group" style="width: 50%; float: right">
                <label for="exampleFormControlInput1">Last Name</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Last Name"
                  name="lastName"
                  v-model="lastName"
                  required
                />
              </div>
            </v-flex>
            <v-flex v-if="!sentVerificationEmail">
              <div class="form-group">
                <label for="exampleFormControlInput1">Email Address</label>
                <input
                  type="email"
                  class="form-control"
                  placeholder="Email Address"
                  name="email"
                  v-model="email"
                  required
                />
              </div>
            </v-flex>
            <v-flex v-if="!sentVerificationEmail">
              <div class="form-group">
                <label for="exampleFormControlInput1">Password</label>
                <input
                  type="password"
                  class="form-control"
                  placeholder="Password"
                  name="password"
                  v-model="password"
                  required
                />
              </div>
            </v-flex>
            <v-flex v-if="!sentVerificationEmail">
              <div class="form-group">
                <label for="exampleFormControlInput1">Confirm Password</label>
                <input
                  type="password"
                  class="form-control"
                  placeholder="Confirm Password"
                  name="passwordConfirm"
                  v-model="passwordConfirm"
                  required
                />
              </div>
            </v-flex>

            <v-flex v-if="!sentVerificationEmail" class="text-xs-center" mt-5>
              <button
                type="button"
                class="btn btn-secondary"
                target="_blank"
                @click.stop="toRoute('signin')"
              >
                Return to Sign In
              </button>
              <button type="submit" class="btn btn-primary">Next</button>
            </v-flex>
            <v-flex v-if="sentVerificationEmail" class="text-xs-center" mt-5>
              <button
                type="button"
                class="btn btn-secondary"
                target="_blank"
                @click.stop="toRoute('signin')"
              >
                Return to Sign In
              </button>
            </v-flex>
             <v-flex class="text-xs-center " mt-4>
              <button type="button" class="google-btn"  @click="googleSignIn">
                <div class="google-icon-wrapper" >
                  <img
                    class="google-icon"
                    src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
                  />
                </div>
                <p class="btn-text"><b>Sign in with google</b></p>
              </button>
            </v-flex>
          </v-layout>
        </form>
        <form @submit.prevent="userSignUpStep2" v-if="signUpStep2">
          <v-layout column>
            <v-flex v-if="!sentVerificationEmail">
              <h4 class="my-4">Add Company Profile</h4>
            </v-flex>
            <v-flex>
              <div class="alert alert-danger" role="alert" v-if="errorMessage">
                {{ errorMessage }}
              </div>
            </v-flex>
            <v-flex v-if="!sentVerificationEmail">
              <div class="form-group">
                <label for="exampleFormControlFile1">Choose file</label>
                <input
                  type="file"
                  class="form-control-file"
                  id="exampleFormControlFile1"
                  @change="onFileChanged"
                  accept=".jpg, .jpeg, .png"
                  required
                />
              </div>
            </v-flex>
            <v-flex v-if="!sentVerificationEmail">
              <div class="form-group" style="width: 48%; float: left">
                <label for="exampleFormControlInput1"
                  >Profession/ Job Title</label
                >
                <input
                  type="text"
                  class="form-control"
                  placeholder="Profession/ Job Title"
                  name="profession"
                  v-model="profession"
                  required
                />
              </div>

              <div class="form-group" style="width: 50%; float: right">
                <label for="exampleFormControlInput1">Organization Name</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Organization Name"
                  name="organizationName"
                  v-model="organizationName"
                  required
                />
              </div>
            </v-flex>

            <v-flex v-if="!sentVerificationEmail && !otherSwitch">
              <div class="form-group">
                <label for="exampleFormControlInput1">Organization Type</label>
                <select
                  class="form-control"
                  name="selectedOrganizationType"
                  v-model="selectedOrganizationType"
                  required
                >
                  <option
                    value="Please Select Organization Type"
                    selected
                    disabled
                  >
                    Please Select Organization Type
                  </option>
                  <option value="Educational Institution">
                    Educational Institution
                  </option>
                  <option value="Studio">Studio</option>
                </select>
              </div>
            </v-flex>
            <v-flex v-if="!sentVerificationEmail && otherSwitch">
              <div class="form-group">
                <label for="exampleFormControlInput1">Organization Type</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Organization Type"
                  name="selectedOrganizationType"
                  v-model="selectedOrganizationType"
                  required
                />
              </div>
            </v-flex>
            <v-flex v-if="sentVerificationEmail">
              <v-layout justify-center>
                <p>
                  We sent a verification link to your email address: {{ email }}
                </p>
              </v-layout>
            </v-flex>
            <v-flex v-if="!sentVerificationEmail">
              <v-switch
                :label="`Other`"
                v-model="otherSwitch"
                @change="toggleSwitch()"
              ></v-switch>
            </v-flex>
            <v-flex v-if="!sentVerificationEmail" class="text-xs-center" mt-5>
              <button
                type="button"
                class="btn btn-secondary"
                @click.stop="toRoute('signin')"
              >
                Return to Sign In
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click.stop="goPrevious()"
              >
                Previous
              </button>

              <button type="submit" class="btn btn-primary">Sign Up</button>
            </v-flex>
            <v-flex v-if="sentVerificationEmail" class="text-xs-center" mt-5>
              <button
                type="button"
                class="btn btn-secondary"
                @click.stop="toRoute('signin')"
              >
                Return to Sign In
              </button>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {db} from '../firebaseDB'

export default {
  data() {
    return {
      errorMessage: "",
      email: "",
      password: "",
      firstName: "",
      lastName: "",
      profession: "",
      organizationName: "",
      organizationType: "",
      passwordConfirm: "",
      showPassword: false,
      showPasswordConfirm: false,
      sentVerificationEmail: false,
      selectedProfileImage: null,
      signUpStep1: true,
      signUpStep2: false,
      otherSwitch: false,
      previous: false,
      selectedOrganizationType: "Please Select Organization Type",
      organizationTypes: [
        "Please Select Organization Type",
        "Educational Institution",
        "Studio",
      ],
      alert: false,
      firstNameRules: [(v) => !!v || "First Name is required"],
      lastNameRules: [(v) => !!v || "Last Name is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          v.substring(v.indexOf("@")) === "@amirbaradaran.com" ||
          "Please sign up with your company email",
      ],
      professionRules: [(v) => !!v || "Profession is required"],
      organizationNameRules: [(v) => !!v || "Organization Name is required"],
      organizationTypeRules: [
        (v) =>
          v.substring(v.indexOf("Please")) !==
            "Please Select Organization Type" ||
          "Organization Type is required",
      ],
      organizationTypeTextRules: [
        (v) => !!v || "Organization Type is required",
      ],
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => v.length >= 6 || "Password should be at least 6 characters",
      ],
      comparePasswords: [
        (v) => !!v || "Password is required",
        (v) => v === this.password || `Passwords don't match`,
      ],
    };
  },
  computed: {
    error() {
      return this.$store.state.error;
    },
    loading() {
      return this.$store.state.loading;
    },
  },
  methods: {
        passwordRegex(v){
      var pattern =new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$")
        if (pattern.test(v)) 
            {return true}
        else{return false}
    },
     googleSignIn() {
      this.$store.dispatch('userGoogleSignIn')
    },
    onFileChanged(event) {
      this.selectedProfileImage = event.target.files[0];
      console.log(this.selectedProfileImage)
    },
    toggleSwitch() {
      if (this.otherSwitch) this.selectedOrganizationType = "";
      else this.selectedOrganizationType = "Please Select Organization Type";
    },
    goPrevious() {
      this.errorMessage = "";
      this.previous = true;
      this.signUpStep1 = true;
      this.signUpStep2 = false;
    },
    toRoute(rname, rparams = {}, query = {}) {
      this.$store.commit("setError", null);
      this.$router.push({ name: rname, params: rparams, query: query });
    },
    validateForm() {
      return this.$refs.form.validate();
    },
    userSignUpStep1() {
    let existed=0
    db.ref(`users`)
      .once('value')
        .then(snapshot => {
            Object.keys(snapshot.val())
            .forEach((k) => {
              if (this.email == snapshot.val()[k].email) existed+= 1
            })
      if (
        this.email.substring(this.email.indexOf("@")) !== "@amirbaradaran.com"
      ) {
        this.errorMessage = "Please sign up with your company email";
      }  else if (existed>0) {
        this.errorMessage = "this email is already linked to another account";
      } else if (this.password.length < 6) {
        this.errorMessage = "Password should be at least 6 characters";
      }  else if ( !this.passwordRegex(this.password)) {
        this.errorMessage = "Password must contains at least : One uppercase (A-Z), One lowercase (a-z), One number (0-9), One special character (-+_!@#$%^&*.,?)";
      }else if (this.password !== this.passwordConfirm) {
        this.errorMessage = "Passwords don't match";
      } else {
        if (!this.previous) {
          this.signUpStep1 = false;
          this.signUpStep2 = true;
          this.errorMessage = "";
        } else {
          this.signUpStep1 = true;
          this.signUpStep2 = false;
          this.previous = false;
        }
      }
       })
    },
    userSignUpStep2() {
      if (
        this.selectedOrganizationType === "" ||
        this.selectedOrganizationType === "Please Select Organization Type"
      ) {
        this.errorMessage = "Please select organization type";
      } else {
        this.errorMessage = "";
        this.$store.dispatch("userSignUp", {
          email: this.email,
          password: this.password,
          firstName: this.firstName,
          lastName: this.lastName,
          profileImage: this.selectedProfileImage,
          profession: this.profession,
          organizationName: this.organizationName,
          organizationType: this.selectedOrganizationType,
        });
      }
    },
    fbAuth: function (event) {
      this.$store.dispatch("fbAuth");
    },
  },
  watch: {
    error(value) {
      if (value) {
        this.alert = true;
      }
    },
    alert(value) {
      if (!value) {
        this.$store.commit("setError", null);
      }
    },
    loading(value) {
      if (value === "true") {

        this.$router.push('plans')
        this.sentVerificationEmail = true;
        this.signUpStep1 = false;
        this.signUpStep2 = true;
      } else {
        if(value === "false"){
        this.sentVerificationEmail = false;
        this.signUpStep1 = true;
        this.signUpStep2 = false;
        }
      }
    },
  },
};
</script>
<style lang="scss" >
.profile {
  padding: 20px;
}
a {
  text-decoration: none;
}
.google-btn {
  width: 184px;
  height: 42px;
  background-color: #4285f4;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0,0,0,.25);
  .google-icon-wrapper {
    position: absolute;
    margin-top: -8px;
    margin-left: 1px;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    background-color: #fff;
  }
  .google-icon {
    margin-top: 8px;
  }
  .btn-text {
    float: right;
    margin: 3px 11px 0 0;
    color: #fff;
    font-size: 14px;
    letter-spacing: 0.2px;
    font-family: "Roboto";
  }
  &:hover {
    box-shadow: 0 0 6px #4285f4;
  }
  &:active {
    background: #1669F2;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Signup.vue